<template>
  <div class="account-page scrollable">
    <div class="page-header">
      <h1>Tinder Accounts</h1>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">
          <i class="mdi mdi-home-outline"></i>
        </el-breadcrumb-item>
        <el-breadcrumb-item>Tinder Accounts</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="top-bar">
      <div class="count-user">
        <p>Total Users Count: {{ usersCount }}</p>
      </div>
      <div class="header-buttons">
        <button
            type="button"
            class="el-button el-button--primary"
        >
            <span>
                <a :href="vnc_server" target="_blank">Open VNC</a></span>
        </button>
        <button v-if="isAdmin"
                type="button"
                class="el-button el-button--primary"
                @click="goToAddTinderAccount"
        >
          <span>Add new</span>
        </button>
      </div>
    </div>
    <div class="top-bar">
      <div class="accounts-filter">
        Show
        <el-select
            v-model="countTinderAccounts"
            @change="changeCount"
            placeholder=" "
            style="width:70px"
        >
          <el-option
              v-for="item in countTinderAccountsOptions"
              :key="item.value"
              :label="item.value"
              :value="item.value"
          >
          </el-option>
        </el-select>
        entries
      </div>
      <div class="accounts-filter">
        Account group
        <el-select
            v-model="showByAccountGroup"
            @change="changeByAccountGroup"
            placeholder="Choose"
            style="width:130px"
        >
          <el-option
              v-for="item in accountGroupOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
    </div> 
    <el-table :data="tinderAccounts" style="width: 100%;" @sort-change="sort" @filter-change="filterChange">
      <el-table-column prop="name" :min-width="130">
        <template slot="header" slot-scope="scope">
          <span class="no-wrap-cell">Phone</span>
        </template>
        <template slot-scope="scope">
          <div>{{ scope.row.phone }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="created_at" sortable sort-key="created_at" :min-width="130">
        <template slot="header" slot-scope="scope">
          <span>Email</span>
        </template>
        <template slot-scope="scope">
          <div>{{ scope.row.email }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="session_expired" :min-width="100" :align="'center'">
        <template slot="header" slot-scope="scope">
          <span>Expires</span>
        </template>
        <template slot-scope="scope">
          {{ scope.row.session_expired }}
        </template>
      </el-table-column>
      <el-table-column prop="account_group_id" :filters="accountGroupOptions" column-key="group" label="Group" sortable sort-key="account_group_id" :min-width="100" :align="'center'">
        <template slot-scope="scope">
          <div :style="{ textAlign: 'center' }">{{ scope.row.account_group_name }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="status" sort-key="status" label="Status" :filters="statusOptions"  column-key="statusColumn" :min-width="100" :align="'center'">
        <template slot-scope="scope">
          <div :style="{ textAlign: 'center' }">
            <span v-if="scope.row.status === 'blocked' && scope.row.permanently_blocked" class="el-tag el-tag--danger" >Bloked</span>
            <span v-else-if="scope.row.status === 'blocked' && scope.row.temporary_blocked" class="el-tag el-tag--warning" >Bloked</span>
            <span v-else-if="scope.row.status === 'verification'" class="el-tag el-tag--info">Verification</span>
            <span v-else-if="scope.row.status === 'active'" class="el-tag el-tag--success">Active</span>            
          </div>
        </template>
      </el-table-column>
      <el-table-column label="Activity" sortable sort-key="autoscan" prop="activity" column-key="autoscan" :filters="[{text:'Autoscan', value:1},{text:'Customer', value:0}]" :min-width="110">
        <template slot-scope="scope">
          <span v-if="scope.row.autoscan" class="el-tag el-tag--success">Autoscan</span>
          <span v-else class="el-tag el-tag--error">Customer</span>
        </template>
      </el-table-column>

      // actions
      <el-table-column width="260px">
        <template slot="header" slot-scope="scope">
          <span>Actions</span>
        </template>
        <template slot-scope="scope">
          <el-button
              size="mini"
              :loading="isSubmitedAuthorize && isIndexClicked === scope.$index"
              @click="handleAuthorize(scope.$index, scope.row)"
          >Authorize
          </el-button>
          <el-button
              size="mini"
              @click="handleEdit(scope.$index, scope.row)"
          >Edit
          </el-button>
          <el-button v-if="isAdmin"
                     size="mini"
                     type="danger"
                     @click="handleDelete(scope.row)"
          >Delete
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagin-wrp">
      <el-pagination
          :current-page="chosenPageFromVuex"    
          :background="true"
          layout="prev, pager, next"
          :page-size="1"
          @current-change="chosePage"
          :total="tinderAccountsMeta.last_page"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import HeaderSortTitle from '../../components/UsersList/HeaderSortTitle'
import axios from 'axios'

export default {
  name: 'TinderPage',
  components: {
    HeaderSortTitle,
  },
  data () {
    return {
      sortBy: {
        autoscan: 0,
        status: 0,
        account_group_id: 0,
        created_at: 0,
      },
      filterTinderAccounts: '',
      countTinderAccountsOptions: [
        {value: 10},
        {value: 25},
        {value: 50},
        {value: 100},
      ],
      vnc_server: `${process.env.VUE_APP_VNC_SERVER}`,
      usersCount: 0,
      showByStatus: 0,
      isSubmitedAuthorize: false,
      isIndexClicked: null,
      statusOptions: [
        {
          value: 'blocked',
          label: 'blocked',
          text: 'Blocked'

        },
        {
          value: 'active',
          label: 'active',
          text: 'Active'
        },
        {
          value: 'verification',
          label: 'verification',
          text: 'Verification'
        }
      ],
      showByAccountGroup: 0,
      accountGroupOptions: [
        {
          value: 0,
          label: 'All',
          text: 'All'
        },
        {
          value: 1,
          label: '18-21',
          text: '18-21',
        },
        {
          value: 2,
          label: '22-25',
          text: '22-25',
        },
        {
          value: 3,
          label: '26-29',
          text: '26-29',
        },
        {
          value: 4,
          label: '30-33',
          text: '30-33',
        },
        {
          value: 5,
          label: '34-37',
          text: '34-37',
        },
        {
          value: 6,
          label: '38-41',
          text: '38-41',
        },
        {
          value: 7,
          label: '42-45',
          text: '42-45',
        },
        {
          value: 8,
          label: '46-49',
          text: '46-49',
        }
      ],
      showByAutoscan: 3,
      autoscanOptions: [
        {
          value: 0,
          label: 'Customer',
          text: 'Customer'

        },
        {
          value: 1,
          label: 'Autoscan',
          text: 'Autoscan'
        },
        {
          value: 3,
          label: 'All',
          text: 'All'
        }
      ],
    }
  },
  computed: {
    ...mapGetters({
      user: 'userData',
      tinderAccounts: 'tinderAccounts/getTinderAccounts',
      tinderAccountsMeta: 'tinderAccounts/getTinderAccountsMeta',
      paidProxies: 'tinderAccounts/getPaidProxies',
      phoneProviders: 'tinderAccounts/getPhoneProviders',
      tinderAccountGroups: 'tinderAccounts/getTinderAccountGroups',
      filters: 'tinderAccountsFilter/getFilterBlock',
      countTinderAccountsFromVuex: 'tinderAccountsFilter/getCountTinderAccounts',
      chosenPageFromVuex: 'tinderAccountsFilter/getChosenPage',
    }),

    chosenPage: {
        get() {
            return this.chosenPageFromVuex;
        },
        set(value) {
            this.$store.dispatch('tinderAccountsFilter/updateChosenPage', value);
        },
    },      

    countTinderAccounts: {
        get() {
            return this.countTinderAccountsFromVuex;
        },
        set(value) {
            this.$store.dispatch('tinderAccountsFilter/updateCountTinderAccounts', value);
            this.updateList();
        },
    },     

    isAdmin() {
      return this.user? this.user.is_admin:false;
    },

    filterBlock() {
      return this.$store.getters['tinderAccountsFilter/getFilterBlock'];
    },    

  },
  mounted () {
    this.$store.dispatch('tinderAccounts/getTinderAccounts')
    this.$store.dispatch('tinderAccounts/getTinderAccountGroups')
    this.$store.dispatch('tinderAccountsFilter/updateFilterBlock', this.filters);
    axios
        .get(`${process.env.VUE_APP_TINDERSTORE_URL}/api/user/total`)
        .then((response) => {
          this.usersCount = response.data.total;
        })
        .catch(error => console.log(error));
    this.updateList();    
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.updateList();
    });
  }, 
  methods: {
    chosePage (e) {
      this.chosenPage = e
      this.updateList()
    },
    filterChange(filter) {
      Object.assign(this.filterBlock, filter)
      this.updateList()
    },
    sort(by) {
      let key  = (typeof by ==="object") ? by.prop : by

      if (this.sortBy[key] === 0) {
        this.sortBy[key] = 1
      } else if (this.sortBy[key] === 1) {
        this.sortBy[key] = -1
      } else if (this.sortBy[key] === -1) {
        this.sortBy[key] = 0
      }
      if(typeof by ==="object" && by.order==null){
        this.sortBy[key] = 0
      }
      this.updateList()
    },
    getFilters() {
      let params = 'sort='
      if (this.sortBy) {
        for (let itm in this.sortBy) {
          if (this.sortBy[itm] === 1) {
            params = `${params}${itm},`
          } else if (this.sortBy[itm] === -1) {
            params = `${params}-${itm},`
          }
        }
      }
      if (params === 'sort=') {
        params = ''
      }
      params = `${params}&page=${this.chosenPage}`
      if (this.countTinderAccounts) {
        params = `${params}&per_page=${this.countTinderAccounts}`
      }

      if (this.showByAccountGroup != 0) {
        params = `${params}&group=${this.showByAccountGroup}`
      }

      if (this.showByStatus != 0) {
        let status = this.statusOptions[this.showByStatus].label.toLowerCase();
        params = `${params}&status=${status}`
      }

      if (this.showByAutoscan != 3) {
        params = `${params}&autoscan=${this.showByAutoscan}`
      }

      if (this.filterTinderAccounts.length) {
        params = `${params}&filter=${this.filterTinderAccounts}`
      }

      if (Object.keys(this.filterBlock).length) {
        Object.entries(this.filterBlock).forEach(([key, value]) => {
          if(value.length === 0){
            return;
          }
          params = `${params}&${key}=`+JSON.stringify(value)
        });
      }

      return params;
    },
    changeCount (e) {
      this.countTinderAccounts = e
      this.updateList()
    },
    changeByAccountGroup(e) {
      this.showByAccountGroup = e
      this.updateList()
    },
    changeByStatus(e) {
      this.showByStatus = e
      this.updateList()
    },
    changeByAutoscan(e) {
      this.showByAutoscan = e
      this.updateList()
    },
    searchTinderAccounts (e) {
      this.filterTinderAccounts = e
      this.updateList()
    },
    updateList() {
      const newParams = this.getFilters();

      // Checking if the parameters have changed
      if (JSON.stringify(this.$route.query) !== JSON.stringify(newParams)) {
        // Saving the filter state to Vuex storage before updating the route
        this.$store.dispatch('tinderAccountsFilter/updateFilterBlock', this.filterBlock);

        // Update request parameters in the URL without changing the route
        this.$router.replace({ query: newParams }).catch(() => {});

        // Updating the data list
        this.$store.dispatch('tinderAccounts/getTinderAccounts', newParams);
      }
    },
    goToAddTinderAccount(){
      this.$router.push({name: 'tinder-account-create'})
    },
    handleEdit (index, row) {
      this.$router.push({name: 'tinder-account-edit', params: {id: row.id}})
    },
    handleDelete (data) {
      this.$store.dispatch('tinderAccounts/deleteTinderAccount', data.id)
    },
    handleAuthorize (index, row) {
      this.isSubmitedAuthorize = true
      this.isIndexClicked = index
      this.$store.dispatch('tinderAccounts/authorizeTinderAccount', row.id)
          .then(response => {
            this.$notify.success({ title: 'Phone number #'+row.phone,  message: 'has beed success authorized.' })
          })
          .catch(error => {
            this.$notify.error({ title: 'Phone number #'+row.phone,  message: 'authorization error' })
          })
          .finally(() => {
            this.isSubmitedAuthorize = false
            this.isIndexClicked = null
            this.updateList()
          })
    }
  }
}
</script>

<style scoped lang="scss">

.account-page {
  overflow-x: hidden;
}
th {
  .cell {
    .pointer {
      cursor: pointer;
    }
  }
}

.accounts-filter {
  width: 200px;
  margin-bottom: 25px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  & > div {
    margin: 0 5px;
  }
}

.header-buttons{
  button{
    a{
      color: #FFFF;
    }
  }
}
</style>
